import AudiotracksListAbstract from './audiotracks-list.abstract.js';

const DEFAULTS = {
	tracks: [],
	default: 'defs' // id
};

/**
 * The class for managing moment list
 *
 * @param {Object} player   Main Player
 * @param {Object=} options Object of option names and values
 * @extends AudiotracksListAbstract
 */
class AudiotracksListFallback extends AudiotracksListAbstract {
	constructor(player, options) {
		let options_ = Object.assign({}, DEFAULTS, options);
		super(player, options_);
		this.player = player;
		this.items = options_.tracks.slice();
		this.items_ = {};
		this.selected = null;
		this.options = options_;
		this.isFirstSelect = true;
		this.init();
	}

	init() {
		this.items.forEach((t) => { 
			this.items_[t.id] = t; 
		});
		this.setSelected();
	}

	setSelected(id) {
		if (!this.allowToChange(id)) return;
		let newId = id || this.options.default;
		this.items.forEach((t) => {
			t.selected = t.id == newId;
			if (t.selected) {
				this.selected = t;
				this.player.trigger({
					type: 'AudiotracksList/update',
					isFirstSelect: this.isFirstSelect,
					trackTitle: t.title
				});
				this.trigger('update');
				this.isFirstSelect = false;
			}
		});
	}

	allowToChange(id) {
		return Object.keys(this.items_).includes(id) && this.selected && this.selected.id !== id || !this.selected;
	}

	isSelected(id) {
		let item = this.items_[id];
		return item && item.selected;
	}

	play(id) {
		if (!this.allowToChange(id) || !this.selected) return;

		let currentTime = this.player.currentTime(),
			currentType = this.player.currentType(),
			volume = this.player.volume(),
			paused = this.player.paused();

		// Нужно для плагина qualitySwitcher.
		this.player.audiotracks().setState({
			playerDataBeforeChangeSrc: {
				currentTime,
				currentType,
				volume,
				paused
			}
		});

		this.setSelected(id);
		this.player.src({
			src: this.selected.url,
			type: currentType
		});

		// Нужно чтобы плагин qualitySwitcher сам восстанавливал состояние плеера после смены src.
		const isRestorePlaying = this.player.usingPlugin('qualitySwitcher') === false || (
			this.player.usingPlugin('qualitySwitcher')
			&& this.player.quality_handler
			&& this.player.quality_handler.supported !== 'native'
		);
		if (isRestorePlaying) {
			this.player.one('canplay', () => {
				this.player.currentTime(currentTime);
				if (paused) {
					this.player.pause();
				}
			});
			this.player.load();
			this.player.play();
			this.player.volume(volume);
		}
		this.player.trigger('Audiotracks/changing-track');
	}
}

export default AudiotracksListFallback;
